import { render, staticRenderFns } from "./Oportunidades.vue?vue&type=template&id=f35c281c&scoped=true"
import script from "./Oportunidades.vue?vue&type=script&lang=js"
export * from "./Oportunidades.vue?vue&type=script&lang=js"
import style0 from "./Oportunidades.vue?vue&type=style&index=0&id=f35c281c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35c281c",
  null
  
)

export default component.exports